import * as React from 'react';
var FormContext = React.createContext({
  labelAlign: 'right',
  vertical: false
});
export default FormContext;